import posthog from 'posthog-js'
import { config } from '@/lib/config'

let initialized = false

export const analytics = {
  init() {
    if (!config.posthog.apiKey || config.isDevelopment) return

    posthog.init(config.posthog.apiKey, {
      api_host: config.posthog.apiHost,
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-mask]',
      },
      persistence: 'localStorage+cookie',
    })
    initialized = true
  },

  identify(userId: string, traits?: Record<string, unknown>) {
    if (!initialized) return
    posthog.identify(userId, traits)
  },

  reset() {
    if (!initialized) return
    posthog.reset()
  },

  capture(event: string, properties?: Record<string, unknown>) {
    if (!initialized) return
    posthog.capture(event, properties)
  },

  capturePageview(path: string) {
    if (!initialized) return
    posthog.capture('$pageview', { $current_url: path })
  },

  getPostHogInstance() {
    return initialized ? posthog : null
  },
}
